<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <!-- <div class="navbar-item ">
          ຍອດເງິນ: <span style="font-size: 24px; margin-left: 5px; margin-right: 5px;"> {{ accountBalance | formatNumberLocal }} </span> ກີບ
      </div> -->
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <!-- <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ການຈັດຊື້</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketpurchaser"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຕະຫຼາດ</span>
            </router-link>

            
          </div>
        </div> -->

       

        
      </div>

      <div class="navbar-end">
        
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ການຈັດຊື້</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketpurchaser"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຕະຫຼາດ</span>
            </router-link>
          </div>
          
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ລາຍງານ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketpurchaser/statement"
              :exact="true"
              active-class="is-active"
            >
              <span>ການເຄື່ອນໄຫວເງິນ</span>
            </router-link>
          </div>
          
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ {{ rolename }}</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/profile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      roleid: null,
      rolename: null,
      accountBalance: 0,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.rolename = this.user.ROLENAME;
    this.username = this.user.USERNAME;
    // console.log("roleid: "+ JSON.stringify(this.roleid))
    

  },
  computed: {
    // user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },

   
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
